/* eslint-disable react/jsx-closing-tag-location */
import {
  faClockRotateLeft,
  faCommentDots,
  faFileLines,
  faKey,
  faQuestionCircle,
  faRightFromBracket,
  faUser,
  faUserDoctor,
} from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { useUserContext } from 'store';

export function AvatarMenuContent() {
  const [user] = useUserContext();
  const domain = process.env.REACT_APP_ENDPOINT_XDSB_domain;
  return [
    {
      id: 'perfil',
      active: !user.role.isProfessional,
      name: 'Perfil',
      title: 'Perfil',
      description: 'Visualize seus dados pessoais',
      path: '/perfil',
      icon: user.role.isProfessional ? faUserDoctor : faUser,
    },
    {
      id: 'privacidade',
      active: !user.role.isProfessional,
      name: 'Privacidade',
      title: 'Privacidade',
      description: (
        <>
          Gerencie sua opção de privacidade <br /> e compartilhamento
        </>
      ),
      path: '/privacidade',
      icon: faKey,
    },
    {
      id: 'historico',
      active: !user.role.isProfessional,
      name: 'Histórico de acessos',
      title: 'Histórico de acessos',
      description: 'Visualize os acessos ao seu RES',
      path: '/historico',
      icon: faClockRotateLeft,
    },
    {
      id: 'faq',
      active: true,
      name: 'Perguntas frequentes',
      title: 'Perguntas frequentes',
      description: (
        <>
          Dúvidas mais comuns sobre o HU <br /> Digital
        </>
      ),
      path: `${domain}/#/questoesfrequentes`,
      icon: faQuestionCircle,
    },
    {
      id: 'terms',
      active: true,
      name: 'Termos de uso',
      title: 'Termos de uso',
      description: 'Leia aqui os termos de uso',
      path: 'https://www.gov.br/ebserh/pt-br/acesso-a-informacao/tratamento-de-dados-pessoais/orientacoes-e-modelos/termo-de-uso-e-aviso-de-privacidade',
      icon: faFileLines,
    },
    {
      id: 'ebserh',
      active: true,
      name: 'Fale com o HU Brasil',
      title: 'Fale com o HU Brasil',
      description: 'Acesso à ouvidoria',
      path: 'https://www.gov.br/ebserh/pt-br/acesso-a-informacao/participacao-social/ouvidoria-geral/ouvidoria',
      icon: faCommentDots,
    },
    {
      id: 'sair',
      active: true,
      name: 'Sair',
      title: 'Sair',
      description: 'Sair do aplicativo',
      path: '/logout',
      icon: faRightFromBracket,
    },
  ];
}
